import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-efe342b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "socials" }

import {ref} from "vue";
import TwitterLogo from '@/components/layout/TwitterLogo';
import GithubLogo from '@/components/layout/GithubLogo';
import HamburgerMenu from "@/components/layout/HamburgerMenu.vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["toggleMobileMenuDisplay"],
  setup(__props, { emit }: { emit: ({
  (e: 'toggleMobileMenuDisplay'): void
}), expose: any, slots: any, attrs: any }) {



const toggleMobileMenuDisplay = () => {
  emit('toggleMobileMenuDisplay');
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(TwitterLogo), { class: "social-icon" }),
      _createVNode(_unref(GithubLogo), { class: "social-icon" }),
      _createVNode(HamburgerMenu, {
        class: "social-icon hamburger-icon",
        onToggleMobileMenuDisplay: toggleMobileMenuDisplay
      })
    ])
  ]))
}
}

})